/* nb-tee-engine.js – layout- og render-motor til t-shirt-builderen.
   1:1-port af California Collection scripts/render.py (reference-implementeringen).
   Konstanterne er godkendt designmaessigt og maa ikke aendres uden aftale.
   Verificeret 23/9 i Chromium mod pakkens builder_eksempler/testcases.json: 18/18 cases og de 5
   kontroldesigns inden for ± 1 px; printfil 02 afviger 0,09 % af pixels fra Pythons (kantudglatning). */
(function (root) {
  'use strict';
  var PRINT_W = 3602, PRINT_H = 4795;          // 30,5 x 40,6 cm @ 300 DPI (trykkeriets print area, t-shirtens bagside)
  var DPI = 300;
  var MARGIN_X = Math.floor(PRINT_W * 0.0075); // 27 px
  var USABLE_W = PRINT_W - 2 * MARGIN_X;       // 3548 px
  var LINE_PITCH = 1.20, MAX_BOTTOM = 0.97;
  var KEEP_RATIO = 0.90, HARD_MIN_FONT_PX = 380, REFERENCE_PLACE = 'CALIFORNIA', MAX_CHARS = 24;
  var GLUE = ['DE', 'DEL', 'DA', 'DI', 'DO', 'DOS', 'DAS', 'DU', 'LA', 'LE', 'LES', 'EL',
              'OF', 'THE', 'VAN', 'VON', 'DEN', 'DER', 'AM', 'AN', 'AUF', 'ST.', 'SAINT'];
  /* Udvidet 23/9 (QA: São Paulo, Kraków, Reykjavík, Bogotá blev afvist): alle latinske versaler, som
     baade Geller og NB Serif Headline har. Pakkens oprindelige saet er en delmaengde. */
  /* + makroner (TAUPŌ, HALEAKALĀ) og rumænsk Ș/Ț (IAȘI) - citat-agenten fandt 17 steder uden dem. */
  var ALLOWED = /^[A-Z0-9ÁÀÂÃÄÅÆÇÉÈÊËÍÌÎÏÑÓÒÔÕÖØÚÙÛÜÝŸŁŃŚŹŻĆĘĄŠŽČŘĚŮŐŰĞŞİŒĀĒĪŌŪȘȚŢ .,’&\-:!?°]+$/;
  /* navy = trykfarven paa ash grey (ejer 25/9). #1B365D (Pantone 534 C) i stedet for #1F2A44: DTG goer moerke
     farver moerkere paa bomuld, og #1F2A44 (L* 17) ville trykke naesten sort (design-review 25/9). */
  var COLORS = { bordeaux: [102, 44, 40], hvid: [255, 255, 255], navy: [27, 54, 93] };

  var family = 'Geller Headline', ctx = null, cache = {};
  function mctx() {
    if (!ctx) { var c = document.createElement('canvas'); c.width = c.height = 8; ctx = c.getContext('2d'); }
    return ctx;
  }
  function fontStr(size) { return size + 'px "' + family + '"'; }

  /* Blaek-kassen som Pillows getbbox: venstre/hoejre/top relativt til tegnets startpunkt. */
  function bbox(text, size) {
    var k = size + '|' + text;
    if (cache[k]) return cache[k];
    var c = mctx(); c.font = fontStr(size); c.textBaseline = 'alphabetic'; c.textAlign = 'left';
    var m = c.measureText(text);
    /* Pillow (raqm) regner kassen fra pennens start til fremrykningen (advance), udvidet med
       blaek der stikker udenfor - ikke kun blaekket. Reference-filerne centreres efter den kasse. */
    var b = { left: Math.min(0, -m.actualBoundingBoxLeft), right: Math.max(m.width, m.actualBoundingBoxRight), ascent: m.actualBoundingBoxAscent };
    b.width = b.right - b.left;
    return (cache[k] = b);
  }
  function textWidth(text, size) { return bbox(text, size).width; }

  function fitSize(text) {
    var lo = 10, hi = 2000, best = 10;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (textWidth(text, mid) <= USABLE_W) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
    }
    return best;
  }
  function topFor(n) { return Math.floor(PRINT_H * ({ 1: .14, 2: .14, 3: .14, 4: .11, 5: .08 }[n] || .06)); }

  function layout(lines) {
    var size = Math.min.apply(null, lines.map(fitSize));
    var top = topFor(lines.length), pitch = Math.floor(size * LINE_PITCH);
    while (top + pitch * lines.length > PRINT_H * MAX_BOTTOM && size > 10) { size -= 5; pitch = Math.floor(size * LINE_PITCH); }
    return { size: size, pitch: pitch, top: top };
  }

  function normalize(t) {
    /* Alle apostrof-varianter (' ‘ ` ´ ′) bliver den typografiske ’ - som i den trykte MENTALLY-bestseller
       (Gelato-ordre 1197, tjekket 24/9: I’M). */
    /* NFC: "a" + loes tilde (kopieret tekst) bliver til ét tegn Ã, ellers afvises São Paulo som ugyldige tegn. */
    t = String(t || '').normalize('NFC').trim().toUpperCase().replace(/['\u2018\u0060\u00B4\u2032]/g, '\u2019');
    return t.replace(/\s*\|\s*/g, '|').replace(/\s+/g, ' ');
  }

  /* Efterled, der gerne staar alene paa sidste linje i navne paa 3+ ord: NEW YORK / CITY,
     SALT LAKE / CITY (i stedet for NEW / YORK CITY). Kun i anchor-tilstand (vores builder). */
  var SUFFIX = ['CITY', 'BEACH', 'ISLAND', 'ISLANDS', 'SPRINGS', 'VALLEY', 'FALLS', 'HEIGHTS', 'PARK', 'BAY', 'COUNTY', 'HILLS'];
  function placeSplits(place, glueFirstOK) {
    var out = [], i, a, b;
    var w = place.split(' ');
    for (i = 1; i < w.length; i++) {
      /* Smaaord maa ikke slutte en linje (RIO DE / JANEIRO) - undtagen som FOERSTE ord i navnet, hvor
         SAINT / PETERSBURG, LA / ROCHELLE laeses fint (QA 23/9: ellers kunne de aldrig deles og krympede). */
      if (GLUE.indexOf(w[i - 1]) >= 0 && !(glueFirstOK && i === 1)) continue;
      a = w.slice(0, i).join(' '); b = w.slice(i).join(' ');
      out.push({ d: Math.abs(textWidth(a, 200) - textWidth(b, 200)), a: a, b: b, i: out.length,
        pref: glueFirstOK && w.length >= 3 && i === w.length - 1 && SUFFIX.indexOf(w[i]) >= 0 });
    }
    /* Bindestreg-navne (STRATFORD-UPON-AVON, WINSTON-SALEM) kan deles EFTER en bindestreg, som bliver
       staaende paa foerste linje - ellers blev de afvist som for smaa (citat-agent 23/9). */
    if (glueFirstOK) {
      var re = /-/g, m;
      while ((m = re.exec(place))) {
        if (m.index < 2 || m.index > place.length - 3 || place[m.index - 1] === ' ' || place[m.index + 1] === ' ') continue;
        a = place.slice(0, m.index + 1); b = place.slice(m.index + 1);
        out.push({ d: Math.abs(textWidth(a, 200) - textWidth(b, 200)) * 1.15, a: a, b: b, i: out.length, pref: false });
      }
    }
    out.sort(function (x, y) { return (y.pref - x.pref) || (x.d - y.d) || (x.i - y.i); });
    return out;
  }

  function candidates(tpl, place, year, glueFirstOK) {
    var fill = function (l) { return l.split('{PLACE}').join(place).split('{YEAR}').join(year); };
    var out = [tpl.map(fill)];
    var idx = -1;
    for (var i = 0; i < tpl.length; i++) if (tpl[i].indexOf('{PLACE}') >= 0) { idx = i; break; }
    if (idx < 0) return out;
    var parts0 = tpl[idx].split('{PLACE}'), pre = parts0[0].trim(), post = parts0[1];
    var head = tpl.slice(0, idx).map(fill), tail = tpl.slice(idx + 1).map(fill);
    if (place.indexOf('|') >= 0) {
      var p = place.split('|').filter(Boolean);
      var forced = [head.concat(pre ? [pre + ' ' + p[0]] : [p[0]], p.slice(1, -1), [p[p.length - 1] + post], tail)];
      if (pre) forced.push(head.concat([pre], p.slice(0, -1), [p[p.length - 1] + post], tail));
      return forced;
    }
    if (pre) out.push(head.concat([pre, place + post], tail));
    var sp = placeSplits(place, glueFirstOK);
    sp.forEach(function (s) { out.push(head.concat([pre ? pre + ' ' + s.a : s.a, s.b + post], tail)); });
    if (pre) sp.forEach(function (s) { out.push(head.concat([pre, s.a, s.b + post], tail)); });
    return out;
  }

  function referenceSize(tpl) {
    return layout(tpl.map(function (l) { return l.split('{PLACE}').join(REFERENCE_PLACE).split('{YEAR}').join('1850'); })).size;
  }

  /* Fejl bærer en kode; teksten til kunden ligger i sektionen (oversaettelig). */
  function fail(code) { var e = new Error(code); e.code = code; throw e; }

  /* opts.anchor (ejer 23/9): skabelonens faste linjer er udgangspunktet - fontstoerrelsen er den, hvor
     den bredeste FASTE linje (fx "RETURN TO") fylder hele bredden, og stedet deles hellere end at goere
     designet mindre (keep = 1,0). Kun et enkelt ord, der ikke kan deles, maa goere designet mindre.
     Uden opts = pakkens reference-regel (CALIFORNIA x 0,90), som testene i pakken beviser. */
  function anchorSize(tpl, year) {
    var fixed = tpl.filter(function (l) { return l.indexOf('{PLACE}') < 0; })
      .map(function (l) { return l.split('{YEAR}').join(year || '1850'); });
    return fixed.length ? Math.min.apply(null, fixed.map(fitSize)) : 0;
  }
  function build(tpl, rawPlace, year, opts) {
    year = year || ''; opts = opts || {};
    var place = normalize(rawPlace);
    if (!place) fail('empty');
    if ((place.match(/\|/g) || []).length > 1 || place[0] === '|' || place[place.length - 1] === '|') fail('breaks');
    var flat = place.replace(/\|/g, ' ');
    if (flat.length > MAX_CHARS) fail('long');
    if (!ALLOWED.test(flat)) fail('chars');
    if (tpl.join(' ').indexOf('{YEAR}') >= 0 && !/^[0-9]{4}$/.test(year)) fail('year');
    if (root.NbTeeEngine.blocked(flat)) fail('blocked');
    var cands = candidates(tpl, place, year, !!opts.anchor);
    var anchor = opts.anchor ? anchorSize(tpl, year) : 0;
    var target = anchor ? anchor * (opts.keep || 1) : referenceSize(tpl) * KEEP_RATIO;
    for (var i = 0; i < cands.length; i++) {
      var s = layout(cands[i]).size;
      if (s >= target) return { lines: cands[i], size: s };
    }
    var best = null, bs = -1;
    cands.forEach(function (ls) {
      var s = layout(ls).size;
      if (s > bs || (s === bs && ls.length < best.length)) { best = ls; bs = s; }
    });
    if (bs < HARD_MIN_FONT_PX) fail('small');
    return { lines: best, size: bs };
  }

  /* Moderering (spec 7.7): hele ord, efter normalisering. Faa, klare ord - stednavne
     som Scunthorpe og Middlesex skal igennem. */
  /* Ejer 25/9: 'Vi er ikke et woke firma - folk bestemmer selv, hvad der staar paa deres t-shirt.' Kun racistiske/
     homofobiske skaeldsord blokeres, fordi Gelato afviser dem i produktionen (kunden ville faa en refunderet ordre). */
  var BLOCK_WORDS = ['NIGGER', 'NIGGA', 'FAGGOT'];
  function blocked(flat) {
    var words = flat.replace(/[^A-ZÆØÅÄÖÜÉÈÑ0-9 ]/g, ' ').split(/\s+/);
    var joined = flat.replace(/[^A-ZÆØÅÄÖÜÉÈÑ]/g, '');
    return words.some(function (w) { return BLOCK_WORDS.indexOf(w) >= 0; }) ||
      /NIGGER|NIGGA|FAGGOT/.test(joined);  // QA 23/9: 'NIGG' og 'CUNT' som delstreng ramte landsbyerne Nigg og Cunter
  }

  /* Tegn printfilen (eller et udsnit af den) paa et canvas-kontekst i printfilens koordinater.
     scale: 1 = fuld oploesning. y0: foerste printfil-raekke i udsnittet (striber til iOS). */
  function draw(c2d, res, color, scale, y0) {
    var lay = layout(res.lines), rgb = COLORS[color] || COLORS.bordeaux;
    scale = scale || 1; y0 = y0 || 0;
    c2d.save();
    c2d.scale(scale, scale); c2d.translate(0, -y0);
    c2d.font = fontStr(lay.size); c2d.textBaseline = 'alphabetic'; c2d.textAlign = 'left';
    c2d.fillStyle = 'rgb(' + rgb.join(',') + ')';
    /* Alle linjer placeres efter VERSALHOEJDEN (hoejden af H), ikke den enkelte linjes hoejeste blaek.
       Foer skubbede en apostrof (I'M), en ring/accent (AARHUS -> Å, É) eller et O's overshoot linjen
       nedad, saa afstanden mellem linjerne blev ujaevn (ejerfund 23/9, "Mentally ser underlig ud"). */
    var cap = bbox('H', lay.size).ascent;
    var y = lay.top;
    res.lines.forEach(function (line) {
      var b = bbox(line, lay.size);
      var x = Math.floor((PRINT_W - (b.right - b.left)) / 2) - b.left;
      c2d.fillText(line, x, y + cap);  // versalernes top lander paa y
      y += lay.pitch;
    });
    c2d.restore();
    return lay;
  }

  /* ---------- PNG-encoder: 3602 x 4795 RGBA, 300 DPI, bygget i striber ----------
     iOS Safari tillader hoejst 16,7 MP pr. canvas; printfilen er 17,3 MP. Derfor tegnes
     filen i vandrette striber og pakkes selv (zlib via CompressionStream). Farven er en
     konstant; kun alfakanalen laeses fra canvas, saa kanterne faar den eksakte trykfarve. */
  var CRC = (function () { var t = new Uint32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } return t; })();
  function crc32(bufs) { var c = 0xFFFFFFFF; bufs.forEach(function (u) { for (var i = 0; i < u.length; i++) c = CRC[(c ^ u[i]) & 255] ^ (c >>> 8); }); return (c ^ 0xFFFFFFFF) >>> 0; }
  function be32(n) { return new Uint8Array([n >>> 24 & 255, n >>> 16 & 255, n >>> 8 & 255, n & 255]); }
  function chunk(type, data) {
    var t = new Uint8Array([type.charCodeAt(0), type.charCodeAt(1), type.charCodeAt(2), type.charCodeAt(3)]);
    return [be32(data.length), t, data, be32(crc32([t, data]))];
  }

  /* Hvidt blaek (navy t-shirt) faar haarde kanter: alfa 0 eller 255 ved taerskel 128, saa trykkeriets
     hvide underbase og blaekket daekker praecis samme pixels (ingen glorie). 1 px = 0,08 mm - usynligt. */
  function printPNG(res, color) {
    /* Haarde kanter ogsaa for navy paa ash (Gelato kan laegge hvid underbase under heather) - design-review 25/9 */
    var hard = color === 'hvid' || color === 'navy';
    if (!('CompressionStream' in root)) return Promise.reject(new Error('no-compression'));
    /* Ukendt blaekfarve = fejl, ALDRIG stille bordeaux paa en sort t-shirt (design-review 25/9) */
    if (!COLORS[color]) return Promise.reject(new Error('unknown-ink'));
    var rgb = COLORS[color], STRIP = 800, W = PRINT_W, H = PRINT_H;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = STRIP;
    var c2d = cv.getContext('2d', { willReadFrequently: true });
    var cs = new CompressionStream('deflate'), wr = cs.writable.getWriter();
    var zipped = new Response(cs.readable).arrayBuffer();
    var rowLen = 1 + W * 4, y0 = 0;
    function next() {
      if (y0 >= H) return wr.close();
      var h = Math.min(STRIP, H - y0);
      c2d.clearRect(0, 0, W, STRIP);
      draw(c2d, res, color, 1, y0);
      var a = c2d.getImageData(0, 0, W, h).data, out = new Uint8Array(rowLen * h);
      for (var r = 0; r < h; r++) {
        var o = r * rowLen, s = r * W * 4;
        out[o] = 1; // filter Sub: kun alfa varierer, saa raekkerne pakkes tæt
        var pa = 0;
        for (var x = 0; x < W; x++) {
          var al = a[s + x * 4 + 3], p = o + 1 + x * 4;
          if (hard) al = al >= 128 ? 255 : 0;
          if (x === 0) { out[p] = al ? rgb[0] : 0; out[p + 1] = al ? rgb[1] : 0; out[p + 2] = al ? rgb[2] : 0; }
          else { var prevOn = pa ? 1 : 0, on = al ? 1 : 0;
            out[p] = (on - prevOn) * rgb[0] & 255; out[p + 1] = (on - prevOn) * rgb[1] & 255; out[p + 2] = (on - prevOn) * rgb[2] & 255; }
          out[p + 3] = (al - pa) & 255; pa = al;
        }
      }
      y0 += h;
      return wr.write(out).then(next);
    }
    return next().then(function () { return zipped; }).then(function (z) {
      var ihdr = new Uint8Array(13); ihdr.set(be32(W), 0); ihdr.set(be32(H), 4); ihdr[8] = 8; ihdr[9] = 6;
      var ppm = Math.round(DPI / 0.0254), phys = new Uint8Array(9); phys.set(be32(ppm), 0); phys.set(be32(ppm), 4); phys[8] = 1;
      var parts = [new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10])]
        .concat(chunk('IHDR', ihdr), chunk('pHYs', phys), chunk('IDAT', new Uint8Array(z)), chunk('IEND', new Uint8Array(0)));
      cv.width = cv.height = 1;
      return new Blob(parts, { type: 'image/png' });
    });
  }

  /* ---------- Fotorealistisk mockup (WebGL) ----------
     Printet skal se ud som en del af stoffet, ikke et lag ovenpaa. Pr. blank-foto beregnes ét kort én gang:
       R = S, lokal skygge fra folderne (fin sloering / grov sloering af lysstyrken; 1 = fladt stof)
       G = T, stoffets egen struktur (high-pass), saa blaekket faar samme korn som fotoet
       B,A = forskydning langs foldernes haeldning, saa lige kanter faar smaa knaek i folderne
     Blaekregler som hos Gelato (DTG):
       lys t-shirt: CMYK-blaek ganges ind i stoffet (intet hvidt blaek) -> folder og vaevning ses igennem
       moerk t-shirt: daekkende hvid underbase + blaek, der tager folderne, strukturen og lidt glans
     Kanterne bloedes ca. 0,6 px (DTG er ikke knivskarp), og alt samples bilineaert.
     Mangler WebGL, bruges den gamle 2D-version nedenfor. */
  var GL = null, MAPS = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function boxBlur(src, W, H, r, passes) {
    var a = src, n = 2 * r + 1;
    for (var p = 0; p < passes; p++) {
      var b = new Float32Array(W * H), c = new Float32Array(W * H), x, y, acc;
      for (y = 0; y < H; y++) {
        var o = y * W; acc = 0;
        for (x = -r; x <= r; x++) acc += a[o + Math.min(W - 1, Math.max(0, x))];
        for (x = 0; x < W; x++) { b[o + x] = acc / n; acc += a[o + Math.min(W - 1, x + r + 1)] - a[o + Math.max(0, x - r)]; }
      }
      for (x = 0; x < W; x++) {
        acc = 0;
        for (y = -r; y <= r; y++) acc += b[Math.min(H - 1, Math.max(0, y)) * W + x];
        for (y = 0; y < H; y++) { c[y * W + x] = acc / n; acc += b[Math.min(H - 1, y + r + 1) * W + x] - b[Math.max(0, y - r) * W + x]; }
      }
      a = c;
    }
    return a;
  }
  function fabricMaps(img, box) {
    var key = box.x + ',' + box.y + ',' + box.width, all = MAPS && MAPS.get(img);
    if (all && all[key]) return all[key];
    var W0 = img.naturalWidth, H0 = img.naturalHeight, bh0 = box.width * PRINT_H / PRINT_W;
    var rb = Math.max(4, Math.round(W0 / 50)), M = rb * 3;   // kun printboksen + margen (8x hurtigere end hele fotoet)
    var rx = Math.max(0, Math.floor(box.x - M)), ry = Math.max(0, Math.floor(box.y - M));
    var W = Math.min(W0, Math.ceil(box.x + box.width + M)) - rx, H = Math.min(H0, Math.ceil(box.y + bh0 + M)) - ry;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var x = cv.getContext('2d', { willReadFrequently: true }); x.drawImage(img, rx, ry, W, H, 0, 0, W, H);
    var px = x.getImageData(0, 0, W, H).data, n = W * H, L = new Float32Array(n), i;
    for (i = 0; i < n; i++) L[i] = (0.2126 * px[i * 4] + 0.7152 * px[i * 4 + 1] + 0.0722 * px[i * 4 + 2]) / 255;
    var Lm = boxBlur(L, W, H, Math.max(1, Math.round(W0 / 420)), 2);   // folderne uden vaevning/stoej
    var Ld = boxBlur(L, W, H, Math.max(3, Math.round(W0 / 160)), 2);   // endnu roligere: kun til forskydning
    var Lb = boxBlur(L, W, H, rb, 3);                                   // lysets store forloeb
    var Sd = new Float32Array(n), out = new Uint8Array(n * 4), d = Math.max(2, Math.round(W0 / 210)), G = 0.006;
    for (i = 0; i < n; i++) Sd[i] = Ld[i] / Math.max(Lb[i], 0.02);
    for (var y = 0; y < H; y++) for (var xx = 0; xx < W; xx++) {
      i = y * W + xx;
      var xl = Math.max(0, xx - d), xr = Math.min(W - 1, xx + d), yu = Math.max(0, y - d), yd = Math.min(H - 1, y + d);
      var gx = (Sd[y * W + xr] - Sd[y * W + xl]) / Math.max(1, xr - xl), gy = (Sd[yd * W + xx] - Sd[yu * W + xx]) / Math.max(1, yd - yu);
      var S = Math.min(2, Lm[i] / Math.max(Lb[i], 0.02));
      var t = Math.max(-1, Math.min(1, (L[i] - Lm[i]) / Math.max(0.03, Lm[i] * 0.12)));
      out[i * 4] = Math.round(S * 127.5);
      out[i * 4 + 1] = Math.round(127.5 + 127.5 * t);
      out[i * 4 + 2] = Math.round(127.5 + 127.5 * Math.max(-1, Math.min(1, gx / G)));
      out[i * 4 + 3] = Math.round(127.5 + 127.5 * Math.max(-1, Math.min(1, gy / G)));
    }
    var m = { W: W, H: H, data: out, tex: null, gl: null, uv: [(box.x - rx) / W, (box.y - ry) / H, box.width / W, bh0 / H] };
    if (MAPS) { all = all || {}; all[key] = m; MAPS.set(img, all); }
    return m;
  }
  var VS = 'attribute vec2 aPos;varying vec2 vUV;void main(){vUV=vec2((aPos.x+1.0)*0.5,(1.0-aPos.y)*0.5);gl_Position=vec4(aPos,0.0,1.0);}';
  var FS = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH', 'precision highp float;', '#else', 'precision mediump float;', '#endif',
    'varying vec2 vUV;uniform sampler2D uMaps,uDesign;uniform vec4 uBox;uniform vec2 uDisp,uTexel;uniform vec3 uInk;uniform float uDark;',
    'void main(){',
    ' vec4 m=texture2D(uMaps,uBox.xy+vUV*uBox.zw);',
    ' float S=m.r*2.0; float T=m.g*2.0-1.0; vec2 D=m.ba*2.0-1.0;',
    ' vec2 uv=vUV+D*uDisp; vec2 h=uTexel*0.6;',
    ' float a=0.4*texture2D(uDesign,uv).a+0.15*(texture2D(uDesign,uv+vec2(h.x,0.0)).a+texture2D(uDesign,uv-vec2(h.x,0.0)).a+texture2D(uDesign,uv+vec2(0.0,h.y)).a+texture2D(uDesign,uv-vec2(0.0,h.y)).a);',
    ' if(uDark<0.5){ float cov=clamp(a*(0.955+0.03*T),0.0,1.0); gl_FragColor=vec4(mix(vec3(1.0),uInk,cov),1.0); }',
    ' else { float cov=clamp(a*(0.965+0.03*T),0.0,1.0); vec3 lin=pow(uInk,vec3(2.2));',
    '  vec3 lit=lin*clamp(S,0.6,1.18)*(0.95+0.08*T)+0.04*max(S-1.0,0.0);',
    '  vec3 c=pow(clamp(lit,0.0,1.0),vec3(1.0/2.2)); gl_FragColor=vec4(c*cov,cov); }',
    '}'].join('\n');
  function glInit() {
    if (GL !== null) return GL;
    GL = false;
    try {
      var c = document.createElement('canvas');
      var g = c.getContext('webgl', { premultipliedAlpha: true, preserveDrawingBuffer: true, antialias: false, alpha: true });
      if (!g) return GL;
      var sh = function (type, src) { var s2 = g.createShader(type); g.shaderSource(s2, src); g.compileShader(s2); if (!g.getShaderParameter(s2, g.COMPILE_STATUS)) throw new Error(g.getShaderInfoLog(s2)); return s2; };
      var pr = g.createProgram(); g.attachShader(pr, sh(g.VERTEX_SHADER, VS)); g.attachShader(pr, sh(g.FRAGMENT_SHADER, FS)); g.linkProgram(pr);
      if (!g.getProgramParameter(pr, g.LINK_STATUS)) throw new Error(g.getProgramInfoLog(pr));
      g.useProgram(pr);
      var buf = g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER, buf);
      g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), g.STATIC_DRAW);
      var aPos = g.getAttribLocation(pr, 'aPos'); g.enableVertexAttribArray(aPos); g.vertexAttribPointer(aPos, 2, g.FLOAT, false, 0, 0);
      var loc = {}; ['uMaps', 'uDesign', 'uBox', 'uDisp', 'uTexel', 'uInk', 'uDark'].forEach(function (k) { loc[k] = g.getUniformLocation(pr, k); });
      g.uniform1i(loc.uMaps, 0); g.uniform1i(loc.uDesign, 1);
      c.addEventListener('webglcontextlost', function (e) { e.preventDefault(); GL = null; });
      GL = { c: c, g: g, loc: loc, design: g.createTexture() };
    } catch (e) { GL = false; }
    return GL;
  }
  function texParams(g) {
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.LINEAR); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.LINEAR);
    g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE);
  }
  function mockupGL(c, img, box, blend, design, color, bx, by, bw, bh) {
    var G = glInit(); if (!G) return false;
    try {
      var g = G.g, m = fabricMaps(img, box), W = m.W, H = m.H;
      G.c.width = bw; G.c.height = bh; g.viewport(0, 0, bw, bh);
      g.pixelStorei(g.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false); g.pixelStorei(g.UNPACK_FLIP_Y_WEBGL, false);
      g.activeTexture(g.TEXTURE0);
      if (!m.tex || m.gl !== G) { m.tex = g.createTexture(); m.gl = G; g.bindTexture(g.TEXTURE_2D, m.tex); texParams(g); g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, W, H, 0, g.RGBA, g.UNSIGNED_BYTE, m.data); }
      else g.bindTexture(g.TEXTURE_2D, m.tex);
      g.activeTexture(g.TEXTURE1); g.bindTexture(g.TEXTURE_2D, G.design); texParams(g);
      g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, g.RGBA, g.UNSIGNED_BYTE, design);
      var ink = COLORS[color] || COLORS.bordeaux, L = G.loc, k = 0.0035;
      g.uniform4f(L.uBox, m.uv[0], m.uv[1], m.uv[2], m.uv[3]);
      g.uniform2f(L.uDisp, k, k * bw / bh); g.uniform2f(L.uTexel, 1 / bw, 1 / bh);
      g.uniform3f(L.uInk, ink[0] / 255, ink[1] / 255, ink[2] / 255); g.uniform1f(L.uDark, blend === 'multiply' ? 0 : 1);
      g.clearColor(0, 0, 0, 0); g.clear(g.COLOR_BUFFER_BIT); g.drawArrays(g.TRIANGLES, 0, 6);
      if (g.isContextLost()) return false;
      c.save(); c.globalCompositeOperation = blend === 'multiply' ? 'multiply' : 'source-over'; c.drawImage(G.c, bx, by); c.restore();
      return true;
    } catch (e) { return false; }
  }

  /* ---------- Mockup: printfilen 1:1 i trykkeriets printboks paa blank-billedet ----------
     Tegnes i scale x blank-oploesningen (2-3x paa retina), saa teksten er skarp.
     Realisme (som et rigtigt tryk, ikke et lag ovenpaa):
       - displacement: trykket foelger stoffets folder (Photoshops Displace med stoffets lysstyrke)
       - hvid: multiply (stoffets skygger ses gennem blaekket), ca. 94 % daekning
       - navy: hvidt blaek ganget med stoffets lysstyrke (skyggekort), clamp 0,55-1,08
       - stoffets fine struktur (high-pass) slaar svagt igennem blaekket paa begge farver */
  function mockup(canvas, blankImg, box, blend, res, color, scale) {
    var S = Math.max(1, Math.min(3, scale || 2));
    var W = blankImg.naturalWidth, H = blankImg.naturalHeight;
    canvas.width = Math.round(W * S); canvas.height = Math.round(H * S);
    var c = canvas.getContext('2d', { willReadFrequently: !glInit() });
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    c.drawImage(blankImg, 0, 0, canvas.width, canvas.height);
    if (!res) return;
    var bx = Math.round(box.x * S), by = Math.round(box.y * S), bw = Math.round(box.width * S), bh = Math.round(bw * PRINT_H / PRINT_W);
    var p = document.createElement('canvas'); p.width = bw; p.height = bh;
    draw(p.getContext('2d'), res, color, bw / PRINT_W, 0);
    if (mockupGL(c, blankImg, box, blend, p, color, bx, by, bw, bh)) return;
    var pd = p.getContext('2d').getImageData(0, 0, bw, bh).data;
    var reg = c.getImageData(bx, by, bw, bh), rd = reg.data, n = bw * bh, i, x, y;
    var L = new Float32Array(n), mean = 0;
    for (i = 0; i < n; i++) { L[i] = (rd[i * 4] + rd[i * 4 + 1] + rd[i * 4 + 2]) / 3; mean += L[i]; }
    mean /= n;
    // Sloeret lysstyrke (boks-filter via integralbillede) = foldernes form uden stoffets korn
    var r = Math.round(4 * S), I = new Float64Array((bw + 1) * (bh + 1));
    for (y = 0; y < bh; y++) { var run = 0; for (x = 0; x < bw; x++) { run += L[y * bw + x]; I[(y + 1) * (bw + 1) + x + 1] = I[y * (bw + 1) + x + 1] + run; } }
    function blur(x, y) {
      var x0 = Math.max(0, x - r), x1 = Math.min(bw, x + r + 1), y0 = Math.max(0, y - r), y1 = Math.min(bh, y + r + 1);
      return (I[y1 * (bw + 1) + x1] - I[y0 * (bw + 1) + x1] - I[y1 * (bw + 1) + x0] + I[y0 * (bw + 1) + x0]) / ((x1 - x0) * (y1 - y0));
    }
    var ink = COLORS[color] || COLORS.bordeaux, K = 0.045 * S, white = blend === 'multiply';
    for (y = 0; y < bh; y++) for (x = 0; x < bw; x++) {
      i = y * bw + x;
      var lb = blur(x, y), off = (lb - mean) * K;
      var sx = Math.round(x + off), sy = Math.round(y + off * 0.6);
      if (sx < 0 || sy < 0 || sx >= bw || sy >= bh) continue;
      var al = pd[(sy * bw + sx) * 4 + 3] / 255; if (!al) continue;
      var grain = Math.max(-1, Math.min(1, (L[i] - lb) / 18));  // stoffets korn, -1..1
      var o = i * 4;
      if (white) {
        al *= Math.max(0.8, Math.min(1, 0.94 + grain * 0.05));
        for (var k = 0; k < 3; k++) rd[o + k] = Math.round(rd[o + k] * (1 - al) + rd[o + k] * ink[k] / 255 * al);
      } else {
        al *= Math.max(0.88, Math.min(1, 0.97 + grain * 0.03));
        /* Skygge fra foldernes lysstyrke (sloeret), ikke stoffets korn - ellers ser hvidt blaek plettet/slidt ud (design-review 23/9). */
        var shade = Math.min(1.08, Math.max(0.55, lb / 44));
        for (var k2 = 0; k2 < 3; k2++) rd[o + k2] = Math.min(255, Math.round(rd[o + k2] * (1 - al) + ink[k2] * shade * al));
      }
    }
    c.putImageData(reg, bx, by);
  }

  function ready(fam) {
    family = fam || family; cache = {};
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load('100px "' + family + '"', 'IF LOST, RETURN TO').then(function () { cache = {}; });
  }

  root.NbTeeEngine = {
    PRINT_W: PRINT_W, PRINT_H: PRINT_H, MARGIN_X: MARGIN_X, USABLE_W: USABLE_W, HARD_MIN_FONT_PX: HARD_MIN_FONT_PX,
    ready: ready, normalize: normalize, layout: layout, build: build, candidates: candidates, blocked: blocked,
    draw: draw, printPNG: printPNG, mockup: mockup
  };
})(window);
